import React from 'react'; // eslint-disable-line
import Search from '../../assets/images/preview/search.png';
import i18n from '../../i18n';

class PreviewLogo extends React.Component {
    getChurchInitials = (church) => { // eslint-disable-next-line
    if(typeof church != 'undefined' && church !=null) {
            return church.split(' ')
                .map((x) => { return x[0]; })
                .join('')
                .substring(0, 4);
        }

        return '';
    };

    render() {
        const { church } = this.props ? this.props : false;
        const { description } = this.props ? this.props : false;
        const { address } = this.props ? this.props : false;
        return (
            <div className="preview-content preview-content_app-settings__logo">
                <div className="status-bar" />
                <div className="logo-preview">
                    <div className="header" />
                    <div className="search-bar">
                        <img alt="" src={`${Search}`} />
                        {church && (church.length > 8) ? church.substring(0, 8) : church}
                    </div>
                    <div className="results">
                        <span className="blue">20</span>
                        {i18n.t('previews.logo.match')}
                        <span className="blue">

                            &quot;
                            {church && (church.length > 8) ? church.substring(0, 8) : church}

                            &quot;
                        </span>
                        {' '}
                    </div>
                    <div className="sample">
                        <div className="logo">
                            {this.props.logo === '' || typeof this.props.logo === 'undefined'
                                ? <h5 className="logo-placeholder">{this.getChurchInitials(church)}</h5> : <img alt="" src={`${this.props.logo}`} />}
                        </div>
                        <div className="church-info">{church}</div>
                        <div className="address">{address}</div>
                        <div className="description">
                            {description && (description.length > 45)
                                ? description.substring(0, 44) : description}
                            ...
                            {' '}
                            <span className="more">{i18n.t('previews.logo.more')}</span>
                        </div>
                    </div>
                    <div className="bottom" />
                </div>
            </div>
        );
    }
}

export default PreviewLogo;
